export interface AnonymousAssessmentTranslations {
  loading: string;
  linkExpired: string;
}

export const anonymousAssessmentTranslationKeys: AnonymousAssessmentTranslations = {
  loading: 'loading',
  linkExpired: 'linkExpired',
};

export const anonymousAssessmentTranslationsEN: AnonymousAssessmentTranslations = {
  loading: 'Loading...',
  linkExpired: 'Link has expired. Please contact your Care Provider.',
};

export const anonymousAssessmentTranslationsES: AnonymousAssessmentTranslations = {
  loading: 'Cargando...',
  linkExpired: 'El enlace ha expirado. Por favor, contacta a tu proveedor de atención.',
};
